import React from "react";
import AjudaModal from "./AjudaModal";

function AjudaTreball({ pestanya, onTancar }) {
  const contingut = CONTINGUT[pestanya] || CONTINGUT.llista;
  return (
    <AjudaModal
      id="treball-ajuda-title"
      titol={contingut.titol}
      lead={contingut.lead}
      onTancar={onTancar}
    >
      {contingut.cos}
    </AjudaModal>
  );
}

const CONTINGUT = {
  llista: {
    titol: "Com funcionen els Treballs",
    lead: "Un Treball és una actuació per a un client: obra, reparació, manteniment. Pot venir d'un pressupost acceptat, o existir sense pressupost.",
    cos: (
      <>
        <section className="dv2-help-section">
          <h4>Llista</h4>
          <ul>
            <li>Doble clic a la fila per consultar. El menú <strong>…</strong> obre Consultar, Modificar, Esborrar i les seccions (Tasques, Contactes, Ofertes…).</li>
            <li>Per defecte es veuen <strong>Pendent + En curs</strong>. Si véns d'un client, no es filtra per estat.</li>
            <li>La cerca mira client, adreça, descripció i número intern.</li>
          </ul>
        </section>
        <section className="dv2-help-section">
          <h4>Seccions de la fitxa</h4>
          <p>
            Un cop dins, el subnav canvia de bloc sense tornar a la llista: Dades, Tasques, Contactes, Ofertes,
            Agrupacions, Organització, Resum i Logística. <strong>Costos</strong> es veu deshabilitat fins que existeixi.
            <strong>Logística</strong> respon què falta per poder executar el treball.
          </p>
        </section>
        <section className="dv2-help-section">
          <h4>Nou treball</h4>
          <p>
            <strong>Nou treball</strong> obre la fitxa buida. Al select de client, <strong>+ Nou client</strong> et porta
            a l'alta de Clients i torna aquí amb el client triat. No es conserva l'esborrany del treball si marxes a
            crear el client.
          </p>
        </section>
      </>
    ),
  },
  dades: {
    titol: "Com funciona la fitxa del Treball",
    lead: "Les dates previstes són planificació. Les reals són el que, amb la informació que tenim, ha passat. El Treball és el marc; les Tasques són l'execució a dins.",
    cos: (
      <>
        <section className="dv2-help-section">
          <h4>Blocs</h4>
          <ul>
            <li>
              <strong>1. Client i contactes</strong>: client obligatori. Els checks de contacte nou (client / altres)
              s'obren a la mateixa línia i només expandixen camps si els actives.
              <strong>Treball relacionat</strong> (opcional) enllaça un treball preexistent sobre el mateix sistema o instal·lació;
              pot ser d'un altre client. Amb Cerca el tries; Treure el desvincula.
            </li>
            <li>
              <strong>2. Descripció</strong> del treball (també es veu a la taula) i horari, si n'hi ha.
            </li>
            <li>
              <strong>3. Classificació</strong>: tipus, estat, prioritat i dates.
            </li>
            <li>
              <strong>4. Adreça</strong>: si el camp és buit, el valor del client surt en gris. En editar-lo, passa a
              ser l'adreça d'aquest treball.
            </li>
          </ul>
        </section>
        <section className="dv2-help-section">
          <h4>Dates i estat</h4>
          <ul>
            <li>Si no hi ha data real, la prevista és la referència. Si n'hi ha, mana la real i la prevista es conserva.</li>
            <li>
              <strong>En curs</strong> sense inici real proposa avui. <strong>Acabat</strong> exigeix inici i final
              reals (pots corregir-los abans de desar).
            </li>
            <li>Les Tasques hereten el marc previst del Treball; no l'amplien elles soles.</li>
          </ul>
        </section>
        <section className="dv2-help-section">
          <h4>Navegació</h4>
          <p>
            A consultar, les fletxes recorren la llista filtrada. De la primera vas a l'última i a l'inrevés. El{" "}
            <strong>?</strong> explica la pantalla on ets; cada secció (Contactes, Ofertes…) té la seva.
          </p>
        </section>
      </>
    ),
  },
  contactes: {
    titol: "Com funcionen els Contactes del Treball",
    lead: "Aquí no es gestiona la identitat global del contacte. Es vinculen les persones útils per coordinar l'obra: cap d'obra, ofici, prevenció, el mateix client…",
    cos: (
      <>
        <section className="dv2-help-section">
          <h4>Vincular o crear</h4>
          <ul>
            <li>
              <strong>Nou contacte</strong>: pots cercar un contacte o una entitat de l'empresa (client,
              proveïdor o empleat) i vincular-lo, o omplir nom i dades per crear un contacte nou.
            </li>
            <li>
              Si poses adreça, cal el joc complet (via, població, província, país, CP…). El país ve per defecte
              Espanya.
            </li>
            <li>Si el programa troba possibles duplicats, et deixa reutilitzar o crear-ne un de nou.</li>
          </ul>
        </section>
        <section className="dv2-help-section">
          <h4>Relació al treball</h4>
          <ul>
            <li>
              <strong>Rol</strong> i <strong>Notes</strong> són d'aquest treball, no de la fitxa del contacte.
            </li>
            <li>
              <strong>Preferent</strong>: com a màxim un per treball. Serveix per saber a qui trucar primer.
            </li>
            <li>
              <strong>Desvincular</strong> treu la relació amb el treball. No esborra el contacte de l'empresa.
            </li>
          </ul>
        </section>
        <section className="dv2-help-section">
          <h4>Llista</h4>
          <p>
            Doble clic per consultar. El <strong>…</strong> obre Consultar, Modificar (només rol, notes i preferent) o
            Desvincular. Les dades de telèfon i adreça de la fitxa del client no es substitueixen: això són contactes
            extra per a l'obra.
          </p>
        </section>
      </>
    ),
  },
  tasques: {
    titol: "Com funcionen les Tasques",
    lead: "Les tasques són la feina d'un treball, en un arbre de N nivells. El nivell 0 no porta color; les subtasques s'indenten i canvien de color. Per crear una subtasca, desplega la fila i el botó de la capçalera passa a Nova subtasca.",
    cos: (
      <>
        <section className="dv2-help-section">
          <h4>Arbre</h4>
          <ul>
            <li>
              Totes les files tenen <strong>▶</strong>, també si encara no tenen fills. El triangle vermell indica
              que ja hi ha subtasques. No hi ha una taula dins d'una altra: és una sola llista jeràrquica.
            </li>
            <li>
              El nivell 0 (tasques d'arrel) no porta color. A partir de les subtasques, el color cicla cada 4
              nivells (rosa, verd, ambre, violeta).
            </li>
            <li>
              Doble clic per consultar. El menú <strong>…</strong> obre Consultar, Modificar, Logística, Nova
              subtasca i Esborrar. Logística només surt si la tasca té material o producte.
            </li>
          </ul>
        </section>
        <section className="dv2-help-section">
          <h4>Crear tasca o subtasca</h4>
          <ul>
            <li>
              Sense cap fila seleccionada, el botó de la capçalera és <strong>Nova tasca</strong> (nivell 0).
            </li>
            <li>
              Selecciona una tasca i desplega-la amb <strong>▶</strong>: el botó passa a{" "}
              <strong>Nova subtasca</strong> d'aquella tasca.
            </li>
            <li>
              Si selecciones una subtasca sense desplegar-la, <strong>Nova subtasca</strong> en crea una de germana
              (el mateix pare).
            </li>
            <li>
              Al <strong>…</strong> de la fila, <strong>Nova subtasca</strong> sempre en crea una de filla d'aquella
              fila, sense haver d'expandir.
            </li>
          </ul>
        </section>
        <section className="dv2-help-section">
          <h4>Tasques cícliques</h4>
          <ul>
            <li>
              Només una tasca sense pare pot ser cíclica. Les subtasques es fan cada vegada i no obren un cicle propi.
            </li>
            <li>
              En marcar-la acabada es genera la següent, amb la mateixa estructura, a partir de la data prevista i de la freqüència.
            </li>
            <li>
              Tancar el treball atura la sèrie. Tancar una agrupació acaba les tasques del grup i, si n'hi ha de cícliques, en genera la següent.
            </li>
          </ul>
        </section>
        <section className="dv2-help-section">
          <h4>Vistes i filtres</h4>
          <ul>
            <li>
              El select <strong>Vista</strong> (General, Planificació, Materials, Execució) canvia les columnes del
              mateix arbre.
            </li>
            <li>
              Els filtres conserven els pares d'una tasca que coincideix, perquè no es perdi el context de l'arbre.
            </li>
            <li>
              Si no hi ha data real, la prevista es veu en cursiva. Quan hi ha data real, mana aquesta.
            </li>
          </ul>
        </section>
      </>
    ),
  },
  fitxaTasca: {
    titol: "Com funciona la fitxa de la Tasca",
    lead: "La quantitat afecta tota la tasca (temps i producte). El producte va al bloc 2 i el temps al 3. Els Detalls van al final.",
    cos: (
      <>
        <section className="dv2-help-section">
          <h4>Blocs</h4>
          <ul>
            <li>
              <strong>1. Quantitat i descripció</strong>: la quantitat de la tasca va davant de la descripció;
              multiplica tant el temps com el producte. Les unitats van amb la quantitat.
            </li>
            <li>
              <strong>2. Producte</strong>: opcional. Si la tasca no en té, només es veu <em>+ Afegir
              material/producte</em>. Pots deixar un material genèric (producte no concretat) o triar un producte
              del catàleg. La quantitat de producte és per cada unitat de tasca. L'origen (Pendent, Estoc o
              Proveïdor) i el proveïdor els resol el servidor en desar; el preu previst és el valor guardat a la
              tasca, no es recalcula només per obrir la fitxa. Si aquest producte té una oferta del treball, es veu
              a la capçalera i es pot triar: el preu el decideix el servidor en desar. Una oferta aplicada es
              reconeix per l'identificador desat, no pel preu. Si l'oferta aplicada ja ha caducat, es conserva i
              s'avisa. Si el pressupost feia servir una oferta caducada que no s'ha aplicat a la tasca, també s'avisa.
              Si ve d'un pressupost, la icona <em>i</em> ho explica: canviar el producte no modifica la partida venuda.
              Com es pensa obtenir el material (estoc, proveïdor o una part pendent) es decideix a{" "}
              <strong>Logística</strong>, no en aquest formulari.
            </li>
            <li>
              <strong>3. Temps</strong>: durada, unitats de temps, grup de mà d'obra i nombre d'empleats.
            </li>
            <li>
              <strong>4. Estat</strong>: prioritat, estat, tipus i facturació.
            </li>
            <li>
              <strong>Dates</strong>: si no hi ha data real, s'edita la prevista. Si n'hi ha, mana la real i la
              prevista es conserva.
            </li>
            <li>
              <strong>Detalls</strong>: text lliure al final. Opcional.
            </li>
          </ul>
        </section>
        <section className="dv2-help-section">
          <h4>Logística d'aquesta tasca</h4>
          <p>
            Si la tasca té material o producte, a dalt de la fitxa es veu el resum d'aquesta necessitat: quant en falta,
            quant està reservat, quant s'ha rebut i on és. <strong>Gestionar aprovisionament</strong> obre les línies
            d'aquesta tasca. <strong>Veure logística del treball</strong> obre la vista agregada del treball.
          </p>
          <p>
            Reservar, rebre o alliberar només s'ofereix aquí quan hi ha una sola línia clara. Si n'hi ha més d'una,
            es fa des de l'aprovisionament de la tasca. Traslladar i corregir estoc només si la necessitat és un sol
            producte o un sol pack.
          </p>
        </section>
        <section className="dv2-help-section">
          <h4>Navegació</h4>
          <p>
            A consultar, les fletxes recorren les tasques del mateix nivell (germanes: mateix pare). De la primera
            vas a l'última i a l'inrevés. Esborrar una tasca també n'esborra les subtasques i les dependències.
          </p>
        </section>
      </>
    ),
  },
  logistica: {
    titol: "Com funciona la logística de la tasca",
    lead: "La tasca diu què es necessita. La logística diu com es pensa obtenir: una part d'estoc, una part de proveïdor, i la resta queda pendent.",
    cos: (
      <>
        <section className="dv2-help-section">
          <h4>On s'obre</h4>
          <ul>
            <li>
              Des de la consulta de la tasca, amb el botó <strong>Logística</strong>, o des del menú <strong>…</strong> de
              la llista. És la mateixa pantalla.
            </li>
            <li>
              Només apareix si la tasca té material o producte. Una tasca només de mà d'obra no s'aprovisiona.
            </li>
            <li>
              <strong>Tornar</strong> et deixa on eres: la consulta o la llista, amb els filtres com els tenies.
            </li>
          </ul>
        </section>
        <section className="dv2-help-section">
          <h4>El resum</h4>
          <ul>
            <li>
              <strong>Necessitat</strong> és la quantitat de producte de tota la tasca: quantitat de tasca per quantitat
              de producte. En una subtasca, la quantitat és per cada unitat del pare, i es multiplica per les
              quantitats de dalt. No es canvia des d'aquí.
            </li>
            <li>
              <strong>Estoc</strong> i <strong>Proveïdor</strong> són les línies normals. <strong>Packs</strong> és la
              quantitat de packs assignats. <strong>Pendent</strong> és el que encara no has decidit. Les línies dels
              components no es tornen a sumar aquí.
            </li>
            <li>Si la necessitat és 0, es pot mirar la pantalla però no afegir línies.</li>
          </ul>
        </section>
        <section className="dv2-help-section">
          <h4>Línies</h4>
          <ul>
            <li>
              Cada línia és un tros de la necessitat. Pots repetir el mateix producte i el mateix origen si les
              observacions o el proveïdor són diferents.
            </li>
            <li>
              Si la tasca ja té un producte concret, les línies són d'aquell producte. Si només té un material, tries
              el producte a cada línia. La tasca continua sent de material genèric.
            </li>
            <li>
              Si el producte és un pack amb la composició activa, la tasca es queda igual i la logística es desglossa
              en components. Cada component pot anar a estoc o a proveïdor. Un pack simple es tracta com un producte
              normal.
            </li>
            <li>
              <strong>Estoc</strong> no porta proveïdor. <strong>Proveïdor</strong> pot quedar sense proveïdor concret
              fins que el decideixis.
            </li>
            <li>
              La quantitat ha de ser més gran que zero i no pot fer que el total passi de la necessitat. Si el servidor
              ho rebutja, es mostra el seu missatge i la taula no canvia.
            </li>
            <li>
              Crear, modificar i esborrar una línia demana el mateix permís que crear, modificar i esborrar una tasca.
            </li>
          </ul>
        </section>
        <section className="dv2-help-section">
          <h4>Packs</h4>
          <ul>
            <li>
              En una tasca de material, <strong>Assignar pack</strong> desa quants packs cobreixen la necessitat, abans
              de crear les línies dels components. Es pot barrejar amb productes normals i amb altres packs. La
              quantitat no pot ocupar el que ja cobreixen les línies anteriors del mateix pack.
            </li>
            <li>
              En una tasca que ja és el pack, la quantitat és la de la tasca. La primera línia de component desa
              l'assignació. Dins del pack es veu, per cada component, el necessari, l'estoc, el proveïdor i el pendent.
            </li>
            <li>El pack està resolt quan tots els components tenen pendent zero.</li>
          </ul>
        </section>
        <section className="dv2-help-section">
          <h4>Reservar estoc</h4>
          <ul>
            <li>
              Només una línia <strong>Estoc</strong> es pot reservar. Reservar no mou el material: el deixa compromès
              per a aquesta tasca i el disponible baixa. Una línia de component reserva aquell component. Una línia
              antiga del pack sencer es veu com a packs i per dins es reparteix entre els components.
            </li>
            <li>
              Es pot reservar una part. El màxim és el pendent de la línia o l'estoc disponible, el que sigui més petit.
              Quan n'entri més, es pot fer una altra reserva sobre la mateixa línia.
            </li>
            <li>
              A la llista es veu l'estat de cada reserva. <strong>Alliberar reserva</strong> surt en editar la línia:
              descomprometeix l'estoc i conserva la fila, que deixa de comptar. No es pot canviar la quantitat d'una
              reserva: se n'allibera una i se'n crea una altra.
            </li>
            <li>
              Una línia amb reserves no s'elimina. Si n'hi ha d'actives, tampoc es pot passar a proveïdor ni baixar la
              quantitat per sota del que ja està reservat.
            </li>
          </ul>
        </section>
        <section className="dv2-help-section">
          <h4>Rebre producte</h4>
          <ul>
            <li>
              Només una línia <strong>Proveïdor</strong> es pot rebre, encara que no tingui proveïdor concret. Rebre
              entra el material a l'estoc de l'empresa del treball i el deixa reservat per a la tasca. El disponible no
              puja. La línia continua sent de proveïdor.
            </li>
            <li>
              Es pot rebre una part. El màxim és el pendent d'aquella línia. Cada recepció demana una ubicació activa de
              la mateixa empresa: magatzem, vehicle, obra o un altre destí. Un altre destí es pot crear des del mateix
              diàleg, amb nom i adreça.
            </li>
            <li>
              Una línia de component es rep com aquell producte. Una línia antiga del pack sencer es rep en packs i per
              dins entren els components, tots a la mateixa ubicació. El pare no suma estoc.
            </li>
            <li>
              <strong>Alliberar reserva</strong> continua sortint en editar la línia. Treu el compromís i no desfà
              l'entrada ni baixa l'estoc físic.
            </li>
            <li>
              Una línia amb recepcions no s'elimina, no canvia de producte ni d'origen, i la quantitat no pot baixar
              del que ja s'ha rebut.
            </li>
          </ul>
        </section>
        <section className="dv2-help-section">
          <h4>Què no fa encara</h4>
          <p>
            No consumeix la reserva en acabar la tasca, no desfà una recepció i no crea comandes ni factures. Tampoc
            canvia l'origen ni el preu previst de la fitxa de la tasca.
          </p>
        </section>
      </>
    ),
  },
  agrupacions: {
    titol: "Com funcionen les Agrupacions",
    lead: "Reuneix tasques del mateix treball en lots (per oficis, plantes, fases…). No substitueix l'arbre de tasques: només les agrupa per treballar-les juntes.",
    cos: (
      <>
        <section className="dv2-help-section">
          <h4>Agrupacions</h4>
          <ul>
            <li>A l'esquerra, <strong>+</strong> crea, el llapis edita i la creu esborra. Clic a l'agrupació per seleccionar-la. <strong>Agrupar</strong> hi posa tasques.</li>
            <li>A la dreta veus les tasques d'aquella agrupació. Sense cap seleccionada, veus totes.</li>
            <li>
              Marcar-la <strong>Acabada</strong> acaba les tasques obertes del grup sense demanar dates.
              Si en neix una cíclica, l'agrupació torna a pendent: és un lot de feina vigent, no un historial.
            </li>
          </ul>
        </section>
        <section className="dv2-help-section">
          <h4>Posar-hi tasques</h4>
          <p>
            Selecciona l'agrupació i entra a mode agrupar. Et queden les tasques lliures i les que ja hi són: marques
            les que vols i les assignes. Les pots tornar a treure després.
          </p>
        </section>
      </>
    ),
  },
  organitzacio: {
    titol: "Com funciona l'Organització",
    lead: "Relacions entre tasques: quina va abans, quina depèn d'una altra. Serveix per no començar una feina abans que l'anterior estigui llesta.",
    cos: (
      <>
        <section className="dv2-help-section">
          <h4>Com es fa</h4>
          <ul>
            <li>Tria una tasca a l'esquerra. A la dreta veus les relacions que ja té.</li>
            <li>Afegeix predecessors o successors i, si cal, un motiu. Esborra la relació amb ✖; el llapis en canvia el motiu.</li>
            <li>El filtre (Totes / Predecessors / Successors) estreta la llista de relacions.</li>
          </ul>
        </section>
      </>
    ),
  },
  logisticaTreball: {
    titol: "Com funciona la logística del treball",
    lead: "Respon què falta per poder executar aquest treball. Cada fila és una necessitat, no una tasca.",
    cos: (
      <>
        <section className="dv2-help-section">
          <h4>Què és una fila</h4>
          <ul>
            <li>Una tasca amb producte concret s'agrupa per aquell producte. Una tasca només de material, pel material.</li>
            <li>Dues tasques del mateix material se sumen. Una tasca de producte concret no entra a la fila del seu material.</li>
            <li>Un pack amb la composició activa es veu com el pack. Els components surten al detall, i no se sumen a una altra fila encara que aquell component tingui la seva pròpia tasca.</li>
          </ul>
        </section>
        <section className="dv2-help-section">
          <h4>Un sol estat per fila</h4>
          <p>Les xifres de dalt reparteixen les files. L'ordre és aquest:</p>
          <ul>
            <li><strong>Pendent d'aprovisionar</strong>: encara falta cobertura funcional, o un component del pack no té línies.</li>
            <li><strong>Pendent de recepció</strong>: hi ha proveïdor previst que encara no ha entrat.</li>
            <li><strong>Pendent de reserva</strong>: l'estoc previst no està reservat per a aquest treball ni és ja a l'obra. Sense això, una línia d'estoc no es dona per completa.</li>
            <li><strong>Pendent de trasllat</strong>: hi ha reserva d'aquest treball que encara no és a l'obra. El que ja és a l'obra, encara que vingui d'un altre moviment, redueix aquest pendent.</li>
            <li><strong>Complet</strong>: no queda cap d'aquests pendents. El treball es considera preparat quan cap fila és pendent.</li>
          </ul>
        </section>
        <section className="dv2-help-section">
          <h4>Accions</h4>
          <ul>
            <li>Reservar, rebre i alliberar actuen sobre una línia concreta del detall. Si n'hi ha diverses, no se'n tria cap sola.</li>
            <li>Traslladar i corregir estoc fan el mateix que a la fitxa del producte. El destí del trasllat es proposa a l'obra d'aquest treball i es pot canviar. No queden lligats a una tasca.</li>
            <li>Corregir estoc demana un motiu. Des d'una fila de material, el trasllat i la correcció són per producte o per pack, al detall.</li>
            <li>Els filtres es poden solapar: una fila pot ser de proveïdor i, alhora, pendent de trasllat. <strong>Pendents</strong> fa servir l'estat principal.</li>
          </ul>
        </section>
      </>
    ),
  },
  resum: {
    titol: "Com funciona el Resum del Treball",
    lead: "Una ullada a l'estat de l'obra: quantes tasques hi ha, quantes pendents o acabades, i els totals que ja es poden calcular.",
    cos: (
      <>
        <section className="dv2-help-section">
          <h4>Què hi ha</h4>
          <p>
            Comptadors de tasques i agrupacions, i els imports o quantitats que el treball ja té. És consulta: per
            canviar res, ves a Dades o a Tasques.
          </p>
        </section>
      </>
    ),
  },
};

export default AjudaTreball;
